import { render } from "./GetStarted.vue?vue&type=template&id=19c13459"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"

import exportComponent from "/Users/taylorcollins/Desktop/ENDIF Interactive/Clients/BAM Advertising/Culligan/Version 4.0/www/wp-content/plugins/culligan-v4-online-store-aqua-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__